<template>
    <div class="modal fade in" data-backdrop="static" data-keyboard="false" id="mFolderPropries">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h4><i class="fa fa-folder-open-o"></i> {{propriedades.title}} </h4>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">×</span>
                    </button>
                </div>
                <div class="modal-body">
                    <li>
                        <strong> Local :</strong> {{propriedades.local}}
                    </li>
                    <li>
                        <strong> Armazenamento : </strong> {{propriedades.armazenamento}}
                    </li>
                    <li>
                        <strong> Documentos Arquivados :</strong> {{propriedades.documentos_arquivados}}
                    </li>
                    <li>
                        <strong> Criado Em:</strong> {{formatDate(propriedades.criado_em)}}
                    </li>
                    <li>
                        <strong> Atualizado Em:</strong> {{formatDate(propriedades.atualizado_em)}}
                    </li>
                </div>
                <div class="modal-footer justify-content-center">
                    <button type="button" data-dismiss="modal" class="btn btn-default float-left"><i
                            class="fa fa-times"></i>
                        {{ $t('words.close')}}</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    export default {
        data() {
            return {
                loading: false,
                propriedades: {
                    title: '',
                    armazenamento: '',
                    documentos_arquivados: 0,
                    local: '',
                    criado_em: '',
                    atualizado_em: ''
                }
            }
        },
        methods: {
            show(payload) {
                axios.get(`/api/nivel/${payload.id}/pasta-propriedades`).then(response => {
                    this.propriedades = response.data;
                    $('#mFolderPropries').modal('toggle');
                }).catch(error => {
                    alert(JSON.stringify(error.response.data));
                });
            }
        }
    }
</script>